export enum QuestionsEnum {
  EASE = 'ease',
  USEFUL = 'useful',
}
export type AvailableQuestions = QuestionsEnum.EASE | QuestionsEnum.USEFUL;
